import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Campus from './pages/Campus';
import Academics from './pages/Academics';
import Admissions from './pages/Admissions';
import StudentLife from './pages/StudentLife';
import News from './pages/News';
import Events from './pages/Events';
import Gallery from './pages/Gallery';
import PTA from './pages/PTA';
import Alumni from './pages/Alumni';
import Scholarships from './pages/Scholarships';
import Support from './pages/Support';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
// Additional route components
import VirtualTour from './pages/VirtualTour';
import NewsDetail from './pages/NewsDetail';
import EventDetail from './pages/EventDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import Sitemap from './pages/Sitemap';
import Testimonials from './pages/Testimonials';
import ClubsAndSocieties from './pages/ClubsAndSocieties';
import AlumniEvents from './pages/AlumniEvents';
import AlumniJoin from './pages/AlumniJoin';
import CorporatePartnerships from './pages/CorporatePartnerships';
import EmmanuelChurch from './pages/EmmanuelChurch';
import IslamicReligion from './pages/IslamicReligion';
import ProjectCommissioning from './pages/ProjectCommissioning';
import AIAssistant from './components/ui/AIAssistant';
import PageTransition from './components/ui/PageTransition';
import TownHistory from './pages/TownHistory';
import Search from './pages/Search';
import { setupAnchorLinks } from './utils/scrollToSection';
import PrizesAndAwards from './pages/PrizesAndAwards';
import IsonyinCommunity from './pages/IsonyinCommunity';
import AlumniExcos from './pages/AlumniExcos';
export function App() {
  useEffect(() => {
    // Setup anchor link scrolling behavior
    const cleanup = setupAnchorLinks();
    return cleanup;
  }, []);
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <AnimatePresence mode="wait" data-id="element-4">
            <Routes data-id="element-5">
              {/* Main pages */}
              <Route path="/" element={<PageTransition data-id="element-7">
                    <Home data-id="element-8" />
                  </PageTransition>} data-id="element-6" />
              <Route path="/about" element={<PageTransition data-id="element-10">
                    <About data-id="element-11" />
                  </PageTransition>} data-id="element-9" />
              <Route path="/campus" element={<PageTransition data-id="element-13">
                    <Campus data-id="element-14" />
                  </PageTransition>} data-id="element-12" />
              <Route path="/academics" element={<PageTransition data-id="element-16">
                    <Academics data-id="element-17" />
                  </PageTransition>} data-id="element-15" />
              <Route path="/admissions" element={<PageTransition data-id="element-19">
                    <Admissions data-id="element-20" />
                  </PageTransition>} data-id="element-18" />
              <Route path="/student-life" element={<PageTransition data-id="element-22">
                    <StudentLife data-id="element-23" />
                  </PageTransition>} data-id="element-21" />
              <Route path="/news" element={<PageTransition data-id="element-25">
                    <News data-id="element-26" />
                  </PageTransition>} data-id="element-24" />
              <Route path="/events" element={<PageTransition data-id="element-28">
                    <Events data-id="element-29" />
                  </PageTransition>} data-id="element-27" />
              <Route path="/gallery" element={<PageTransition data-id="element-31">
                    <Gallery data-id="element-32" />
                  </PageTransition>} data-id="element-30" />
              <Route path="/pta" element={<PageTransition data-id="element-34">
                    <PTA data-id="element-35" />
                  </PageTransition>} data-id="element-33" />
              <Route path="/alumni" element={<PageTransition data-id="element-37">
                    <Alumni data-id="element-38" />
                  </PageTransition>} data-id="element-36" />
              <Route path="/scholarships" element={<PageTransition data-id="element-40">
                    <Scholarships data-id="element-41" />
                  </PageTransition>} data-id="element-39" />
              <Route path="/support" element={<PageTransition data-id="element-43">
                    <Support data-id="element-44" />
                  </PageTransition>} data-id="element-42" />
              <Route path="/contact" element={<PageTransition data-id="element-46">
                    <Contact data-id="element-47" />
                  </PageTransition>} data-id="element-45" />
              {/* Search route */}
              <Route path="/search" element={<PageTransition data-id="element-49">
                    <Search data-id="element-50" />
                  </PageTransition>} data-id="element-48" />
              {/* Prizes and Awards route */}
              <Route path="/prizes-and-awards" element={<PageTransition data-id="element-52">
                    <PrizesAndAwards data-id="element-53" />
                  </PageTransition>} data-id="element-51" />
              {/* Additional routes */}
              <Route path="/virtual-tour" element={<PageTransition data-id="element-55">
                    <VirtualTour data-id="element-56" />
                  </PageTransition>} data-id="element-54" />
              <Route path="/news/:slug" element={<PageTransition data-id="element-58">
                    <NewsDetail data-id="element-59" />
                  </PageTransition>} data-id="element-57" />
              <Route path="/events/:slug" element={<PageTransition data-id="element-61">
                    <EventDetail data-id="element-62" />
                  </PageTransition>} data-id="element-60" />
              <Route path="/privacy-policy" element={<PageTransition data-id="element-64">
                    <PrivacyPolicy data-id="element-65" />
                  </PageTransition>} data-id="element-63" />
              <Route path="/terms-of-use" element={<PageTransition data-id="element-67">
                    <TermsOfUse data-id="element-68" />
                  </PageTransition>} data-id="element-66" />
              <Route path="/sitemap" element={<PageTransition data-id="element-70">
                    <Sitemap data-id="element-71" />
                  </PageTransition>} data-id="element-69" />
              <Route path="/testimonials" element={<PageTransition data-id="element-73">
                    <Testimonials data-id="element-74" />
                  </PageTransition>} data-id="element-72" />
              <Route path="/student-life/clubs" element={<PageTransition data-id="element-76">
                    <ClubsAndSocieties data-id="element-77" />
                  </PageTransition>} data-id="element-75" />
              {/* Isonyin Community route */}
              <Route path="/isonyin-community" element={<PageTransition data-id="element-79">
                    <IsonyinCommunity data-id="element-80" />
                  </PageTransition>} data-id="element-78" />
              {/* Emmanuel Church route */}
              <Route path="/emmanuel-church" element={<PageTransition data-id="element-82">
                    <EmmanuelChurch data-id="element-83" />
                  </PageTransition>} data-id="element-81" />
              {/* Islamic Religion route */}
              <Route path="/islamic-religion" element={<PageTransition data-id="element-85">
                    <IslamicReligion data-id="element-86" />
                  </PageTransition>} data-id="element-84" />
              {/* Project Commissioning route */}
              <Route path="/project-commissioning" element={<PageTransition data-id="element-88">
                    <ProjectCommissioning data-id="element-89" />
                  </PageTransition>} data-id="element-87" />
              {/* Town History route */}
              <Route path="/town-history" element={<PageTransition data-id="element-91">
                    <TownHistory data-id="element-92" />
                  </PageTransition>} data-id="element-90" />
              {/* Alumni specific routes */}
              <Route path="/alumni/events" element={<PageTransition data-id="element-94">
                    <AlumniEvents data-id="element-95" />
                  </PageTransition>} data-id="element-93" />
              <Route path="/alumni/join" element={<PageTransition data-id="element-97">
                    <AlumniJoin data-id="element-98" />
                  </PageTransition>} data-id="element-96" />
              <Route path="/alumni/excos" element={<PageTransition data-id="element-100">
                    <AlumniExcos data-id="element-101" />
                  </PageTransition>} data-id="element-99" />
              {/* Support specific routes */}
              <Route path="/support/corporate-partnerships" element={<PageTransition data-id="element-103">
                    <CorporatePartnerships data-id="element-104" />
                  </PageTransition>} data-id="element-102" />
              {/* 404 page */}
              <Route path="*" element={<PageTransition data-id="element-106">
                    <NotFound data-id="element-107" />
                  </PageTransition>} data-id="element-105" />
            </Routes>
          </AnimatePresence>
        </main>
        <Footer data-id="element-108" />
        <AIAssistant data-id="element-109" />
      </div>
    </Router>;
}